<button *ngIf="site" nz-button [nzType]="type" (click)="navigate()">
  <i *ngIf="icon" nz-icon [nzType]="icon" nzTheme="outline"></i>
  <i *ngIf="!icon" nz-icon nzType="arrow-right" nzTheme="outline"></i>
  {{ description ? description : site.emoji + ' ' + site.title}}
</button>
